<template>
  <div style="width: 900px">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-model-item label="状态" prop="to_status">
            <a-select v-model="form.to_status" placeholder="状态" style="width: 100%">
              <a-select-option v-for="(item, key) in statusOptions" :key="key" :value="item.node_id">
                <a-badge :status="problemStatus[item.node_id].status" :color="problemStatus[item.node_id].color" :text="item.node_name" />
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="处理人" prop="handler">
            <a-select v-model="form.handler" placeholder="处理人" style="width: 100%" show-search :filter-option="utils.filterOption">
              <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-model-item label="备注" prop="comment">
            <vditor-editor v-model="form.comment" :height="200" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-button type="primary" :loading="loading" @click="onSubmit"> 提交 </a-button>
  </div>
</template>
<script>
import { userList } from '@/api/system/auth';
import { problemStatusUpdate } from '@/api/event/problem';
import VditorEditor from '@/components/VditorEditor';
import { problemStatus } from '@/utils/dictionary';
export default {
  components: { VditorEditor },
  props: {
    problemId: {
      type: Number
    },
    statusOptions: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      loading: false,
      problemStatus,
      form: {
        id: this.problemId,
        to_status: null,
        handler: null,
        comment: ''
      },
      rules: {
        to_status: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        handler: [{ required: true, message: '处理人不能为空', trigger: 'blur' }],
        comment: [{ required: true, message: '备注不能为空', trigger: 'blur' }]
      },
      userData: []
    };
  },
  created() {
    this.getUserList();
  },
  methods: {
    // 获取用户列表
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users;
      });
    },

    // 提交
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          problemStatusUpdate(this.form)
            .then(() => {
              this.loading = false;
              this.form.handler = null;
              this.form.to_status = null;
              this.form.comment = '';
              this.$emit('success');
              this.$message.success('状态变更成功');
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 4px;
}
/deep/.ant-form-item-label {
  line-height: 32px;
}
</style>
